import React from 'react';
import {
  Box, Paper, Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Chip
} from '@mui/material';
import {
  Speed, AccessTime, Code, Wifi
} from '@mui/icons-material';
import { PageTiming } from '../../lib/instantPageService';

interface PerformanceMetricsProps {
  timing: PageTiming;
}

const PerformanceMetrics: React.FC<PerformanceMetricsProps> = ({ timing }) => {

  const metrics = [
    { 
      label: 'Temps d\'interaction', 
      value: timing.time_to_interactive, 
      icon: <Speed color="primary" />,
      threshold: { good: 1000, average: 2500 }
    },
    { 
      label: 'DOM complet', 
      value: timing.dom_complete, 
      icon: <Code color="primary" />,
      threshold: { good: 1000, average: 2500 }
    },
    { 
      label: 'Plus grand élément peint', 
      value: timing.largest_contentful_paint, 
      icon: <Code color="primary" />,
      threshold: { good: 2500, average: 4000 }
    },
    { 
      label: 'Délai première interaction', 
      value: timing.first_input_delay, 
      icon: <AccessTime color="primary" />,
      threshold: { good: 100, average: 300 }
    },
    { 
      label: 'Temps de connexion', 
      value: timing.connection_time, 
      icon: <Wifi color="primary" />,
      threshold: { good: 100, average: 300 }
    },
    { 
      label: 'Temps d\'attente', 
      value: timing.waiting_time, 
      icon: <AccessTime color="primary" />,
      threshold: { good: 100, average: 300 }
    },
    { 
      label: 'Temps de téléchargement', 
      value: timing.download_time, 
      icon: <AccessTime color="primary" />,
      threshold: { good: 300, average: 700 }
    }
  ];

  return (
    <Paper elevation={0} variant="outlined">
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Métrique</TableCell>
              <TableCell align="right">Valeur (ms)</TableCell>
              <TableCell align="right">Statut</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {metrics.map((metric, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    {metric.icon}
                    {metric.label}
                  </Box>
                </TableCell>
                <TableCell align="right">{metric.value}</TableCell>
                <TableCell align="right">
                  <Chip 
                    label={metric.value <= metric.threshold.good ? 'Bon' : 
                      metric.value <= metric.threshold.average ? 'Moyen' : 'Lent'}
                    color={metric.value <= metric.threshold.good ? 'success' : 
                      metric.value <= metric.threshold.average ? 'warning' : 'error'}
                    size="small"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default PerformanceMetrics;
